import { render } from "./AlertExibTable.vue?vue&type=template&id=a5f1f2b8&scoped=true"
import script from "./AlertExibTable.vue?vue&type=script&lang=js"
export * from "./AlertExibTable.vue?vue&type=script&lang=js"

import "./AlertExibTable.vue?vue&type=style&index=0&id=a5f1f2b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f1f2b8"]])

export default __exports__